import React, { FC } from 'react'
import { InputDescriptionProps } from './InputDescriptionTypes'


export const InputDescription: FC<InputDescriptionProps> = ({ 
  helpText, 
  children }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width:'100%',
        color: 'var(--slate12)',
        fontSize: '0.8rem',
        gap: 4
      }}
    >
      {children}
      {helpText}
    </div>
  )
}

export default InputDescription